$(function() {

	$.fn.extend({
		// 複数の class を持っているかチェックする関数
		hasClasses: function(selector) {
			if (typeof selector == 'string') {
				selector = (selector.match(/^\./)) ? selector.replace(/^\./, '').split('.') : $.trim(selector).split(' ');
			}
			for (var i=0, hit=0, len=selector.length; i<len; i++) {
				if (this.hasClass(selector[i])) {
					hit++;
				}
			}
			return (hit === len);
		}
	});

	// rowspan 付与関数
	function rowspanAdd() {
		// クラスを記録
		a = [];
		$('.table-left td.frameNum').each(function(i, habiclass) {
			var habiClass = $(this).attr('class');
			a.push(habiClass);
		});
		// 重複してるクラスをカウント
		var counts = [];
		for (var i=0; i<a.length; i++) {
			var key = a[i];
			counts[key] = (counts[key]) ? counts[key] + 1 : 1;
		}
		// rowspan 付与
		Object.keys(counts).forEach(function(key) {
			var class_array = key.split(' ');
			var iClass = '';
			for (var i=0;i<class_array.length;i++) {
				iClass += '.' + class_array[i];
			}
			if ($('.table-left td.frameNum').hasClasses(key)) {
				$(iClass).not(':first').css('display', 'none');
				$(iClass).eq(0).attr('rowspan', counts[key]);
			}
		});
	}
	rowspanAdd();

	function currentAdd() {
		var url = window.location.href;
		// メニューリストに current付与
		if (url.match(".+\/(horse)\/(local)\/[0-9]+\/.*$")) {
			$(".keywordLists a:contains('予想')").parent('li').addClass('current');
		}
		else if (url.match(".+\/(horse)\/(local)\/(news)\/$")) {
			$(".keywordLists a:contains('ニュース＆コラム一覧')").parent('li').addClass('current');
		}
		// 場リストに current付与
		var filename = url.match(".+/(.+?)([\?#;].*)?$")[1]; // 拡張子付きファイル名
		var dirname = window.location.pathname.replace(filename,'');
		if (url.match(".+\/(horse)\/(local)\/[0-9]+\/.*$") || url.match(".+\/(horse)\/(tokusyu)\/(jra|sonoda)\/.*$")) {
			$(".place-list li a[href='"+dirname+"']").parent('li').addClass('current');
		}
		// レースリストに current付与
		$(".race-list a[href='"+filename+"']").parent('li').addClass('current');
	}
	currentAdd();

});
